import { MenuItem, TextField, TextFieldProps } from '@mui/material';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { forwardRef } from 'react';

export type SelectBaseProps = Omit<
  TextFieldProps,
  'children' | 'error' | 'onChange'
> & {
  options: { id: string; label: string }[];
  error?: any;
  onChange?: any;
};

const SelectBase = forwardRef(
  ({ options, error, ...rest }: SelectBaseProps, ref) => {
    return (
      <TextField
        select
        error={!!error}
        inputRef={ref}
        helperText={<IncFormHelperText error={error} />}
        {...rest}
      >
        {options.map(opt => (
          <MenuItem key={opt.id} value={opt.id} data-testid="Select.Option">
            {opt.label}
          </MenuItem>
        ))}
      </TextField>
    );
  },
);

export default SelectBase;
